import { intersection } from "lodash";

export type Role = { name: string; precedence: number };

interface Roles {
  [key: string]: Role;
}

export const ROLES: Roles = {
  ADMIN: { name: "admin", precedence: 1 },
};

const getPrecedenceFromName = (name: string) => {
  const id = Object.keys(ROLES).find((key) => ROLES[key].name === name);

  if (id) {
    return ROLES[id].precedence;
  } else {
    return Infinity;
  }
};

const getRoleWithHighestPrecedence = (userRoles: Array<string> = []) => {
  let highestPrecedence = Infinity;

  userRoles.forEach((name) => {
    const precedence = getPrecedenceFromName(name);
    if (precedence > highestPrecedence) {
      highestPrecedence = precedence;
    }
  });
  return highestPrecedence;
};

export const getUserRoles = (user: any) => {
  if (!user) {
    return [];
  } else {
    const {
      signInUserSession: {
        // @ts-ignore
        accessToken: { payload: { "cognito:groups": groups } } = {},
      } = {},
    } = user || {
      signInUserSession: {
        accessToken: { payload: { "cognito:groups": [] } },
      },
    };

    return groups;
  }
};

export const isUserAuthorized = (
  groups: Array<string> = [],
  neededRoles: Array<Role> = []
) => {
  const roleNames = neededRoles.map(({ name }) => name);
  let authorized = false;
  if (groups.length === 0) {
    return false;
  }
  authorized = intersection(roleNames, groups).length > 0;

  if (!authorized) {
    const highestPrecedence = getRoleWithHighestPrecedence(groups);
    authorized = neededRoles.some(
      ({ precedence }) => highestPrecedence > precedence
    );
  }
  return authorized;
};
